import { Outlet, useNavigate, useSearchParams, useLocation } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAppContext } from '../Context';
import { useTranslation } from '../TranslationContext';
import SearchBox from './functions/SearchBox';
import TermsOverlay from './functions/TermsOverlay';
import ImageModal from './functions/ImageModal';
import Download from './functions/Download';
import bowser from 'bowser';
import '../css/Main.css';
import '../css/Basket.css';
import '../css/Choices.css';
import '../css/ConfirmDialog.css';
import '../css/Download.css';
import '../css/Gallery.css';
import '../css/ImageModal.css';
import '../css/Language.css';
import '../css/SearchBox.css';
import '../css/Terms.css';
import '../css/MainMobile.css';
//import { CookieBanner } from '@schlomoh/react-cookieconsent';
import CookieConsent from "react-cookie-consent";

const Layout = () => {
	const [searchParams] = useSearchParams();
	const qrCodeValue = searchParams.get('qr');
    const { isLoading, showSearchBox, submittedCode, setShowTerms, setQrCodeValue, showModal } = useAppContext();
	const { t, setLanguage, translationButtons } = useTranslation();
    const location = useLocation();
	const navigate = useNavigate();
	const currentYear = new Date().getFullYear();
	const handleClick = () => {
		navigate('/');
		window.location.reload();
	};
	const [isSafariBelow14, setIsSafariBelow14] = useState(false);

	useEffect(() => {
		const browser = bowser.getParser(window.navigator.userAgent);
		const isValidBrowser = browser.satisfies({
			macos: {
				safari: "<14"
			},
			mobile: {
				safari: '<=14',
			},
		});
		if (isValidBrowser) {
			setIsSafariBelow14(true);
			alert("This site may not work as expected as your browser is not supported. Please update to the latest version of Safari.");
		}
	}, []);
	
	useEffect(() => {
		if (qrCodeValue !== null) {
			//resetContext();
			setQrCodeValue(qrCodeValue);
		}
	}, [setQrCodeValue]);
	
    useEffect(() => {
        if (location.pathname !== '/' && (submittedCode === null || submittedCode === '')) {
            navigate('/');
        }
    }, [location, navigate, submittedCode]);

	return (
		<>
			{isLoading && (
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					transition={{ duration: 0.5, ease: "easeInOut" }}
					className="loadingIndicator"
				>
					<motion.div
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}
						transition={{ duration: 0.5, ease: "easeInOut" }}
						className="loadingContainer"
					>
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							transition={{ duration: 0.5, ease: "easeInOut" }}
							className="loader"
						></motion.div>
					</motion.div>
				</motion.div>
			)}
			<CookieConsent
				location="bottom"
				cookieName="accepted"
				buttonText={t('cookieAccept')}
				style={{ background: "#FFFFFF", color: "#000000", boxShadow: "rgba(0, 0, 0, 0.2) 0px -10px 25px", transition: "transform 0.4s ease-in-out, visibility 0.3s", padding: "25px", alignItems: "center" }}
				buttonStyle={{ background: "#FF7F50", color: "#FFFFFF", borderRadius: "10px", minWidth: "80px", minHeight: "40px", fontWeight: "bold", border: "medium", padding: "10px 15px", transition: "filter 0.4s" }}
				expires={150}
			>
				<h3 style={{ marginTop: "0px" }}>{t('cookieTitle')}</h3>
				<span style={{ fontFamily: "Trebuchet MS", fontSize: "14px" }}>{t('cookieMessage')}</span>{" "}
			</CookieConsent>
			<div className={`structureTop ${!showSearchBox ? 'smallerTop' : ''}`}> 
				<div className="logoSearch">
					<div className="mainLogo" onClick={handleClick}></div><SearchBox />
				</div>
			</div>
			<div className="structureMiddle">
				<Outlet />
			</div>
			<div className="structureBottom">
				<div className="terms">
					<span>{t('deleteNotice')}</span><br/>
					<span className="showTerms" id="lower" onClick={() => setShowTerms(true)}><u>{t('linkTerms')}</u></span> - <a href="https://www.imageinsight.com/privacy-policy/" target="_blank" rel="noreferrer">{t('linkPrivacy')}</a> - <a href="https://www.imageinsight.com/support-cantfind/" target="_blank" rel="noreferrer">{t('linkHelp')}</a><br/>
					Copyright ImageInsight.com {currentYear} {t('copyright')}
				</div>
			</div>
			<TermsOverlay/>
			<AnimatePresence>
				{showModal && <ImageModal/>}
			</AnimatePresence>
			<Download/>
		</>
	);
};

export default Layout;